(function (angular) {
	'use strict';

	angular
		.module('staticChartModule')
		.controller('StaticChartController', [
			'globalConfig',
			'StaticChartService',
			'STATIC_BASE_PATH',
			StaticChartFunction
		]);

	function StaticChartFunction(
		globalConfig,
		StaticChartService,
		STATIC_BASE_PATH) {
		
		var staticChart = this;
		if(globalConfig.chartKey) {
			var chartUrl = STATIC_BASE_PATH + '/' + resolveStaticResource('static/json/data-visualizations/' + globalConfig.chartKey + '.json');

			StaticChartService.fetchChartInfo(chartUrl).then(function(response) {
				angular.extend(staticChart, response.data);
			});
		}
	}
})(window.angular);